import { styled } from '@mui/material/styles';
import TextEditor from '@components/TextEditor';

export const ReplyEditor = styled(TextEditor)({
    marginTop: 8,
    paddingBottom: '0 !important',
    '& .editor-toolbar': {
        bottom: '16.5px !important',
    },
});

export const CheckboxWrapper = styled('div')({
    display: 'flex',
    alignItems: 'center',
    marginBottom: 8,
    '& .MuiCheckbox-root': {
        padding: 4,
    },
});

export const ReplyContainer = styled('div')({
    display: 'flex',
    marginTop: 16,
});

export const ReplyContent = styled('div')({
    display: 'flex',
    flexDirection: 'column',
    flex: 1,
    minWidth: 0,
});

export const ReplyBtnWrapper = styled('div', {
    shouldForwardProp: prop => prop !== 'hasEmptyReply' && prop !== 'isExternal',
})(({ hasEmptyReply, isExternal }) => ({
    marginTop: hasEmptyReply ? 0 : isExternal ? 8 : 12,
    '@media (max-width: 1024px)': {
        '& button': {
            padding: '0 8px',
        },
    },
}));

export const FormWrapper = styled('div')({
    width: '100%',
    '@media(max-width: 665px)': {
        width: 'auto',
        margin: ' 0 -16px',
        padding: '8px 16px 0',
        borderTop: '1px solid rgba(0, 0, 0, 0.12)',
    },
});

export const ReplyIconWrapper = styled('div', {
    shouldForwardProp: prop => prop !== 'isForm',
})(({ isForm }) => ({
    marginRight: '8px',
    width: '40px',
    minWidth: '40px',
    maxWidth: '40px',
    height: '40px',
    borderRadius: '100%',
    border: '0.5px solid rgba(0, 0, 0, 0.12)',
    backgroundColor: 'var(--action-hover)',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    color: 'var(--primary-main)',
    '& svg path': {
        fill: 'var(--text-tertiary)',
        fillOpacity: 1,
    },
    '@media (max-width: 1024px)': {
        width: '32px',
        minWidth: '32px',
        maxWidth: '32px',
        height: '32px',
        ...(isForm && { display: 'none' }),
    },
}));

export const ReplyAuthorWrapper = styled('div')({
    marginRight: '8px',
    '@media (max-width: 1024px)': {
        '& .MuiAvatar-root': {
            width: 32,
            height: 32,
        },
    },
});
